// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2fdhK","title":"Images45_title__2u-4C","images":"Images45_images__26Tn7"};